export default __webpack_public_path__ + "./images/noPhoto24.68e5dcbe.svg";